import { useDisclosure, useToast } from '@chakra-ui/react';
import { AxiosError, AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import { useState } from 'react';
import * as Yup from 'yup';

import { saveCredentials } from '@helpers/credentials';
import { generateRandomId } from '@helpers/generateRandomId';
import useResponsive from '@hooks/useResponsive';
import { ISingleBaseResponse } from '@interfaces/IBaseResponse';
import { ICredentials } from '@interfaces/IProfile';
import { actionPostLogin } from '@libraries/api/login/login.function';
import { ILoginResponse, IParamLogin } from '@libraries/api/login/login.types';
import { configEnv } from '@libraries/config';
import { showToast } from '@utils/constant';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { appDeviceId, appMenu } from 'store/Common';

export const useAction = () => {
  const router = useRouter();
  const toast = useToast();
  const { isMobile } = useResponsive();
  const deviceId = useRecoilValue(appDeviceId);
  const [tempResLogin, setTempResLogin] = useState(null);

  const setMenu = useSetRecoilState(appMenu);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const setDeviceId = useSetRecoilState(appDeviceId);

  const initialValues: IParamLogin = {
    username: configEnv.stage === 'local' ? 'superadmin' : '',
    password: configEnv.stage === 'local' ? '123123' : '',
    device_id: deviceId?.device_id,
    type: isMobile ? 'mobile' : 'desktop',
  };

  const handleConfirm = () => {
    const cred: ICredentials = {
      token: tempResLogin?.access_token,
      profile: tempResLogin?.user,
    };
    saveCredentials(cred);
    setMenu(tempResLogin.role?.menus);
    let redirectUrl = returnUrl ? `${returnUrl}` : '/';
    router.push(redirectUrl);
  };

  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const onShowPassword = () => setIsShowPassword(!isShowPassword);

  const returnUrl = router?.query?.returnUrl || '/';

  const { isLoading, mutate } = actionPostLogin();

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      username: Yup.string().required('Username harus diisi!'),
      password: Yup.string().required('Password harus diisi'),
      device_id: Yup.string().nullable(),
      type: Yup.string().nullable(),
    }),
    onSubmit: (values: IParamLogin) => {
      handleSubmit(values);
    },
  });
  const handleSubmit = (values: IParamLogin) => {
    const body: IParamLogin = {
      ...values,
      type: isMobile ? 'mobile' : 'desktop',
      device_id: deviceId?.device_id,
    };
    if (!body.device_id) {
      const generatDeviceId = generateRandomId(20);
      body.device_id = generatDeviceId;
    }
    mutate(body, {
      onSuccess: ({
        data: { data: resLogin },
      }: AxiosResponse<ISingleBaseResponse<ILoginResponse>>) => {
        const cred: ICredentials = {
          token: resLogin?.access_token,
          profile: resLogin?.user,
        };
        setDeviceId({ device_id: body?.device_id });

        if (
          deviceId?.device_id === '' &&
          resLogin?.role?.code !== 'super_admin' &&
          resLogin?.role?.code !== 'admin_sekolah'
        ) {
          onOpen();
          setTempResLogin(resLogin);
        } else {
          saveCredentials(cred);
          setMenu(resLogin.role?.menus);
          setTimeout(() => {
            let redirectUrl = returnUrl ? `${returnUrl}` : '/';
            router.push(redirectUrl);
          }, 300);
        }
      },
      onError: (err: AxiosError<ISingleBaseResponse<null>>) => {
        const { errors } = err.response.data;
        setError(errors);
        showToast({
          toast,
          title: 'Opps!',
          description: errors,
          status: 'error',
        });
      },
    });
  };

  return {
    error,
    formik,
    isShowPassword,
    onShowPassword,
    isLoading,
    deviceId,
    isOpen,
    onClose,
    handleConfirm,
  };
};
